import { PaginateQuery } from "core/resources/types/shared";
import { FormaPagamento } from "resources/enums/tenant";
import { RelatorioBaseData } from "core/features/relatorios/typings";

export interface OrcamentoDto {
  id: string;
  createdAt: string;
  descricao: string;
  quantidadeOrcamento: number;
  status: { id?: StatusOrcamentoEnum; nome: string };
}

export interface OrcamentoCotacaoFornecedor {
  id: string;
  nomeFornecedor: string;
  contato: string | null;
  email: string | null;
  dataCotacao: string;
  dataValidade: string;
  formaPagamentoId: FormaPagamento;
  valorTotal: number;
  total: number;
  observacao?: string | null;
  items: OrcamentoCotacaoItem[];
  anexos?: {
    id: string;
    referencia: string;
  }[];
}

export interface OrcamentoCotacaoItem {
  id?: string;
  nome?: string;
  orcamentoItemId?: string;
  unidadeMedidaId: UnidadeMedidaEnum | undefined;
  quantidade?: number;
  valorUnitario?: number;
  indisponivel?: boolean;
  total?: number;
  aprovadoEm?: string | null;
}
export interface OrcamentoDadosForm {
  id?: string;
  descricao: string;
  statusOrcamentoId?: StatusOrcamentoEnum;
  orcamentoItems: OrcamentoItem[];
}

export interface OrcamentoDados {
  id?: string;
  descricao: string;
  statusOrcamentoId: { id?: StatusOrcamentoEnum; nome: string };
  orcamentoItems: OrcamentoItem[];
}

export type OrcamentoItemPdfResponse = RelatorioBaseData &
  OrcamentoItemResponse;

export interface OrcamentoItemResponse {
  unidadeId: string;
  unidade: string;
  orcamentoItems: OrcamentoItem[];
}

export interface OrcamentoItem {
  id?: string;
  nome: string;
  quantidade: number | undefined;
  unidadeMedidaId: UnidadeMedidaEnum | undefined;
}

export interface OrcamentoItensCotados {
  id: string;
  quantidade: string;
  item: string;
}

export interface OrcamentoCotacaoItemForm {
  id?: string;
  nomeFornecedor: string;
  contato: string;
  email: string | null;
  dataCotacao: string;
  dataValidade: string;
  formaPagamentoId?: FormaPagamento;
  valorTotal?: number;
  observacao?: string;
  prazoEntregaDias?: string;
  valorTipo?: "individual" | "total";
  arquivosExcluidos: string[];
  anexos: (
    | File
    | {
        id: string;
        referencia: string;
        mimetype: string;
        nome: string;
        temp?: boolean;
      }
  )[];
  orcamentoCotacaoItems: OrcamentoCotacaoItem[];
}

export interface CotacaoAprovarItemsForm {
  id: string;
  aprovado: boolean;
  total: number;
}

export interface FiltroOrcamentos extends PaginateQuery {
  statusId: StatusOrcamentoEnum | undefined;
}

export enum StatusOrcamentoEnum {
  PendenteAprovacao = "CAF477BD-0E21-4D0E-8AF4-092EC3CB0000",
  ConsultaFornecedor = "CAF477BD-0E21-4D0E-8AF4-092EC3CB0001",
  Aprovado = "CAF477BD-0E21-4D0E-8AF4-092EC3CB0002",
}

export enum PrazoEntregaEnum {
  TresDias = 3,
  CincoDias = 5,
  SeteDias = 7,
  QuinzeDias = 15,
  TrintaDias = 30,
  SecentaDias = 60,
}

export enum UnidadeMedidaEnum {
  Unidade = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0000",
  Metro = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0001",
  MetroQuadrado = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0002",
  MetroCubico = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0003",
  Quilo = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0004",
  Grama = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0005",
  Litro = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0006",
  Mililitro = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0007",
  Minuto = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0008",
  Hora = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0009",
  Dia = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0010",
  Mes = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0011",
  Ano = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0012",
  Caixa = "AAAA77BD-0E21-4D0E-8AF4-092EC3CB0013",
}

export interface ItemCotado {
  id: string;
  nome: string;
  unidadeMedidaId: string;
  quantidade: number;
  orcamentoId: string;
}
